<template>
    <div style="z-index: 999999999999; position: fixed; background: rgba(0,0,0,.3); top: 0; left: 0; right: 0; bottom: 0;">
        <div style="position: relative; max-width: min(470px, 90vw); max-height: Calc(100vh - 40px); overflow-y: scroll; background: #fff; border-radius: 10px; margin: 20px auto; width: auto; padding: 10px;">
            <v-btn style="position: sticky; top: 5px; right: 16px; float: right;" fab small @click="$emit('close')"><v-icon>close</v-icon></v-btn>
            <span class="blue--text text--darken-3" style="display: inline-block; padding: 10px 0 0 15px; font-weight: 600; font-size: 20px;">Debug info</span><br/>
            <br/>
            <div style="line-height: 2; padding: 15px 15px; border: 1px solid #bbb; border-radius: 3px;">
                <label style="position: absolute; margin-top: -30px; margin-left: -5px; font-weight: 600; background: #fff; padding: 0 5px;">General info</label>
                Flutter version: {{ flutterVersion }}<br/>
                JS version: {{ appVersion }}<br/>
                Device ID: {{ deviceId }}<br/>
                FirstRunTS: {{ firstRunTS | toHumanReadable }}<br/>
                FirstRunTSFS: {{ firstRunTSFS | toHumanReadable }}<br/>
                Last update checked: {{ lastVersionCheck | toHumanReadable }}<br/>
                <span @click="IAPgetOfferings">GET OFFERINGS</span><br/>
                <span @click="IAPrestore">RESTORE PURCHASES</span><br/>
                <span @click="forceUpdate">FORCE UPDATE</span><br/>
                <span @click="clearVersionCheckDate">CLEAR VERSION CHECK DATE</span>
            </div>
            <br/>
            <div style="line-height: 2; padding: 15px 15px; border: 1px solid #bbb; border-radius: 3px;">
                <label style="position: absolute; margin-top: -30px; margin-left: -5px; font-weight: 600; background: #fff; padding: 0 5px;">AppStorage</label>
                <div v-if="!showAppStorage" @click="showAppStorage = !showAppStorage" style="text-align: center">show</div>
                <div v-if="showAppStorage">
                    <pre>{{ appStorage }}</pre>
                     <div @click="showAppStorage = !showAppStorage" style="text-align: center">hide</div>
                </div>
            </div>
            <br/>
            <div style="width: 100%; line-height: 2; padding: 15px 15px; border: 1px solid #bbb; border-radius: 3px;">
                <label style="position: absolute; margin-top: -30px; margin-left: -5px; font-weight: 600; background: #fff; padding: 0 5px;">IAP</label>
                <div v-if="!showIap" @click="showIap = !showIap" style="text-align: center">show</div>
                <div v-if="showIap" style="width: 100%; max-width: min(440px, 90vw); overflow-x: scroll;">
                    Premium: {{ IAP.hasSubscriptionToComponent('premium') }}<br/>
                    isPro: {{ IAP.hasAccessToComponent('premium') }}<br/>
                    Default product: {{ IAP.getDefaultSku() }}<br/>
                    <pre>{{ IAP }}</pre>
                     <div @click="showIap = !showIap" style="text-align: center">hide</div>
                </div>
            </div>

            <template v-for="(logItem, i) in flutterEventLog">
                <br/>
                <div style="line-height: 2; padding: 15px 15px; border: 1px solid #bbb; border-radius: 3px;">
                    <label style="position: absolute; margin-top: -30px; margin-left: -5px; font-weight: 600; background: #fff; padding: 0 5px;">Flutter event: {{ logItem.eventName }}</label>
                    <div v-if="!showFlutterEvent[i]" @click="$set(showFlutterEvent,i, true)" style="text-align: center">show</div>
                    <div v-if="showFlutterEvent[i]">
                        <pre>{{ logItem.data }}</pre>
                         <div @click="$set(showFlutterEvent,i, false)" style="text-align: center">hide</div>
                    </div>
                </div>
            </template>
            <br/>

            <template v-for="(logItem, i) in errorCollection">
                <br/>
                <div style="line-height: 2; padding: 15px 15px; border: 1px solid #bbb; border-radius: 3px;">
                    <label style="position: absolute; margin-top: -30px; margin-left: -5px; font-weight: 600; background: #fff; padding: 0 5px;">Error #{{i}}</label>
                    <div v-if="!showError[i]" @click="$set(showError,i, true)" style="text-align: center">show</div>
                    <div v-if="showError[i]">
                        <pre>{{ typeof error === 'string' ? logItem : JSON.stringify(logItem) }}</pre>
                         <div @click="$set(showError,i, false)" style="text-align: center">hide</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
    import { IAPgetOfferings, IAPupdateOfferings } from "@/utils/iap";
    import { checkVersion } from "@/utils/force-update";
    export default {
        data: () => ({
            showIap: false,
            appVersion: window.appVersion || 'not set',
            flutterEventLog: window.flutterEventLog || [],
            flutterVersion: localStorage.getItem('flutterVersion') || 'not set',
            IAP: window.IAP || {},
            showFlutterEvent: [],
            showError: [],
            deviceId: localStorage.getItem('deviceId') || 'not set',
            showAppStorage: false,
            appStorage: window.appStorage ? Object.fromEntries(window.appStorage) : {},
            firstRunTS: localStorage.getItem('firstRunTS') || 'not set',
            firstRunTSFS: localStorage.getItem('firstRunTSFS') || 'not set',
            lastVersionCheck: localStorage.getItem('lastVersionCheck') || 'not set',
            errorCollection: window.errorCollection || [],
        }),
        methods: {
            forceUpdate() {
                checkVersion(true);
            },
            clearVersionCheckDate() {
                localStorage.removeItem('lastVersionCheck');
            },
            IAPgetOfferings() {
                IAPgetOfferings(true);
            },
            IAPrestore() {
                window.IAP.restore();
            }
        },
        filters: {
            toHumanReadable(ts) {
                try {
                    if (ts === 'not set') return ts;
                    const options = {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        second: 'numeric'
                    };
                    return new Intl.DateTimeFormat('hu-HU', options).format(ts);
                } catch(e) {
                    return ts;
                }
            }
        }
    }
</script>
